module.exports = __webpack_public_path__ + "static/media/Location_Book-Page25.277397d2.png";